<template>
  <div class="" id="mapModal" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static">
    <v-layout justify-center>
      <v-flex xs12 class="map">
        <div :id="mapName" class="google-map"></div>
      </v-flex>
    </v-layout>
    <p class="text-center">
      <v-btn @click="getAddress" class="primary">
        {{$t('customer.get-address')}}
      </v-btn>
    </p>
  </div>
</template>

<script>
export default {
  name: 'MapModal',
  props: ['edit'],
  data () {
    return {
      mapName: 'modal-map',
      map: null,
      bounds: null,
      marker: null,
      geocoder: null,
      defaultLat: '51.4768467',
      defaultLng: '-0.0005284'
    }
  },
  methods: {
    init () {
      this.initMap()
    },
    initMap () {
      var initialPos = ''
      if (this.edit.latitude !== '' && this.edit.longitude !== '' && !isNaN(this.edit.latitude) && !isNaN(this.edit.longitude)) {
        initialPos = new google.maps.LatLng(this.edit.latitude, this.edit.longitude)
      } else {
        // 現在位置取得
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function (position) {
            // navigator.geolocation.getCurrentPosition(function (position) {
            const pos = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            }
            self.map.setCenter(pos)
            self.marker.setPosition(pos)
            initialPos = new google.maps.LatLng(position.coords.latitude, position.coords.longitude)
          }, function () {
            self.handleLocationError(true)
          },
            {
              timeout: 5000
            }
          )
        }
        // デフォルトの位置情報
        initialPos = new google.maps.LatLng(this.defaultLat, this.defaultLng)
      }
      /* eslint-disable no-new */
      /* global google */
      this.map = new google.maps.Map(document.getElementById(this.mapName), {
        center: initialPos,
        zoom: 14,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        streetViewControl: false,
        mapTypeControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM
        },
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_CENTER
        }
      })

      let self = this
      /* global $ */
      google.maps.event.addListener(this.map, 'click', function (event) {
        self.moveMarker(event.latLng)
      })

      this.marker = new google.maps.Marker({
        position: initialPos,
        map: this.map,
        draggable: true
      })
      this.geocoder = new google.maps.Geocoder()

      this.marker.setMap(this.map)
    },
    handleLocationError (browserHasGeolocation) {
      /* eslint-disable no-new */
      /* global PNotify */
      $(function () {
        new PNotify({
          title: 'Notice',
          text: browserHasGeolocation ? 'The Geolocation service failed.' : 'Your browser doesn\'t support geolocation.',
          type: 'success',
          styling: 'bootstrap3',
          buttons: {
            sticker: false
          }
        })
      })
    },
    moveMarker (latLng) {
      this.marker.setPosition(latLng)
    },
    getAddress () {
      if (this.marker === null) {
        return
      }

      const self = this
      const position = this.marker.getPosition()

      this.edit.latitude = position.lat()
      this.edit.longitude = position.lng()

      // address を求める
      this.geocoder.geocode({ location: position }, function (results, status) {
        if (status === 'OK') {
          console.log('Geocoder: results:', results)
          if (results[0]) {
            self.edit.locationAddress = results[0].formatted_address
          } else {
            console.warn('Geocoder: No results found')
          }
        } else {
          console.error('Geocoder: Failed :' + status)
        }
        self.$emit('selectLocation', self.edit)
      })
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style>
.map {
  position: relative;
  width: 100%;
  height: 200px;
}
.google-map {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// MapModal.vue?a1251c40